import axios from "axios";
import ResponseAlerts from "../functions/ResponseAlerts";

const BASE_ACCESS_ROUTE = "access-control-service/access-routes";

const RESOURCES = {
   LIST_GROUPS_PAGINATED: (
      page,
      searchText,
      organizationId,
      orderBy,
   ) =>
      `${BASE_ACCESS_ROUTE}/paginated?page=${page}&limit=8&searchBy=${searchText}&orderBy=${orderBy.collumnTitle}&orderDirection=${orderBy.orderDirection}&id_organization=${organizationId}`,

   CREATE_ACCESS_ROUTE: () => BASE_ACCESS_ROUTE,
   DELETE_ACCESS_ROUTE: (accessGroupId) =>
      `${BASE_ACCESS_ROUTE}/${accessGroupId}`,
   UPDATE_ACCESS_ROUTE: (accessGroupId) =>
      `${BASE_ACCESS_ROUTE}/${accessGroupId}`,
   GET_ONE_UUID: (uuid) => `${BASE_ACCESS_ROUTE}/uuid/${uuid}`,
};

class AccessRouteService {
   static async listAccessRoutesPaginated(
      page,
      searchText,
      organizationId,
      orderBy,
      cancelToken,
   ) {
      try {
         const response = await axios.get(
            RESOURCES.LIST_GROUPS_PAGINATED(
               page,
               searchText,
               organizationId,
               orderBy,
            ),
            {
               signal: cancelToken,
            }
         );
         return response;
      } catch (error) {
         console.log(error);
         ResponseAlerts({
            response: error.response,
            errorMessage: "Erro ao listar rota de acesso",
         });
         return error.response;
      }
   }

   static async listCondominiumAccessRoutes(condominiumId) {
      try {
         const response = await axios.get(
            RESOURCES.LIST_CONDOMINIUM_ACCESS_ROUTE(condominiumId),
         );
         return response;
      } catch (error) {
         console.log(error);
         ResponseAlerts({
            response: error.response,
            errorMessage: "Erro ao listar rota de acesso do condomínio",
         });
         return error.response;
      }
   }

   static async getOneUuid(uuid) {
      try {
         return await axios.get(RESOURCES.GET_ONE_UUID(uuid));
      } catch (error) {
         console.error(error);
         ResponseAlerts({
            response: error.response,
            errorMessage: "Erro ao obter rota de acesso de acesso",
         });
         return error.response;
      }
   }

   static async createAccessRoute(payload) {
      try {
         const response = await axios.post(
            RESOURCES.CREATE_ACCESS_ROUTE(),
            payload,
         );
         ResponseAlerts({
            response: response,
            successMessage: "Rota de Acesso cadastrado com sucesso",
         });
         return response;
      } catch (error) {
         console.log(error);
         ResponseAlerts({
            response: error.response,
            errorMessage: "Erro ao cadastrar rota de acesso",
         });
         return error.response;
      }
   }

   static async updateAccessRoute(accessGroupId, payload) {
      try {
         const response = await axios.put(
            RESOURCES.UPDATE_ACCESS_ROUTE(accessGroupId),
            payload,
         );
         ResponseAlerts({
            response: response,
            successMessage: "Rota de Acesso editado com sucesso",
         });
         return response;
      } catch (error) {
         console.log(error);
         ResponseAlerts({
            response: error.response,
            errorMessage: "Erro ao editar rota de acesso",
         });
         return error.response;
      }
   }
   static async deleteAccessRoute(accessGroupId) {
      try {
         const response = await axios.delete(
            RESOURCES.DELETE_ACCESS_ROUTE(accessGroupId),
         );
         ResponseAlerts({
            response: response,
            successMessage: "Rota de Acesso excluído com sucesso",
         });
         return response;
      } catch (error) {
         console.log(error);
         ResponseAlerts({
            response: error.response,
            errorMessage: "Erro ao excluir rota de acesso",
         });
         return error.response;
      }
   }
}
export default AccessRouteService;
